export default "__VITE_ASSET__67268f83__"